// extracted by mini-css-extract-plugin
module.exports = {"block":"return_block__33lKl","second":"return_second__1wJwD","link":"return_link__2W3cQ"};